// extracted by mini-css-extract-plugin
export default {"component":"lPeXylFH","title":"nLQMzokP","buttons":"anivDlPw","button":"FyLyE6d_","other":"qc_OgoRz","icon":"pCfPfPyE"};